export enum FlsaType {
    Exempt = 'EXEMPT',
    NonExempt = 'NON_EXEMPT'
}
